import { render, staticRenderFns } from "./OtpNotValid.vue?vue&type=template&id=7b151b2a&"
import script from "./OtpNotValid.vue?vue&type=script&lang=ts&"
export * from "./OtpNotValid.vue?vue&type=script&lang=ts&"
import style0 from "./OtpNotValid.vue?vue&type=style&index=0&id=7b151b2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports